import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/DesignSystem.css'
import dsHero from "../../../assets/images/Design System.png";
import dsTokens from "../../../assets/images/Design System.png";

const DesignSystemPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Design Systems – BuddyTech Solutions </title>
        <meta name="description" content="Create consistent UI libraries and components across your digital product suite." />
        <meta name="keywords" content="design systems, UI components" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Design Systems – BuddyTech Solutions" />
        <meta property="og:description" content="Create consistent UI libraries and components across your digital product suite." />
        <meta property="og:keywords" content="design systems, UI components" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/uiux/designsystem" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Design Systems – BuddyTech Solutions" />
        <meta name="twitter:description" content="Create consistent UI libraries and components across your digital product suite." />
        <meta name="twitter:keywords" content="design systems, UI components" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="ds-container">
        <header className="ds-hero">
          <div className="ds-hero-content">
            <h1>Design System Creation</h1>
            <p>
              We build scalable, reusable, and consistent design systems that streamline collaboration between designers and developers.
            </p>
          </div>
          <img src={dsHero} alt="Design System Hero" className="ds-hero-img" />
        </header>

        <section className="ds-section">
          <div className="ds-text">
            <h2>What We Build</h2>
            <p>
              A robust design system ensures visual consistency, accelerates product development, and enhances UX. Our systems are built with scalability and accessibility in mind.
            </p>
            <ul>
              <li>Design Tokens & Component Libraries</li>
              <li>Color, Typography & Spacing Rules</li>
              <li>Responsive Grid & Layout Standards</li>
              <li>Interaction Patterns & Accessibility</li>
              <li>Documentation for Handoff & Scaling</li>
            </ul>
          </div>
          <img src={dsTokens} alt="Design System Tokens" className="ds-img" />
        </section>

        <section className="ds-tools">
          <h2>Tools We Use</h2>
          <div className="tools-grid">
            <span>Figma</span>
            <span>Adobe XD</span>
            <span>Storybook</span>
            <span>Zeroheight</span>
            <span>Zeplin</span>
            <span>Sketch</span>
            <span>Notion</span>
            <span>Tokens Studio</span>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 1</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:sureshperiyasamy98@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919361367843" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919361367843">Call Us</a>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 2</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:jprakash0502@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919994694028" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919994694028">Call Us</a>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 3</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:swethadee1407@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/916379359918" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+916379359918">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default DesignSystemPage;